import { render, staticRenderFns } from "./reportGenSummaryCourse.vue?vue&type=template&id=2c5253d2&scoped=true"
import script from "./reportGenSummaryCourse.vue?vue&type=script&lang=js"
export * from "./reportGenSummaryCourse.vue?vue&type=script&lang=js"
import style0 from "./reportGenSummaryCourse.vue?vue&type=style&index=0&id=2c5253d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5253d2",
  null
  
)

export default component.exports